"use strict";
//   outils/boutons
Object.defineProperty(exports, "__esModule", { value: true });
exports.factureButton = exports.avoirButton = exports.imprimerButton = exports.ouvrirButton = exports.actualiserButton = exports.dupliquerButton = exports.autresButton = exports.validerButton = exports.annulerButton = exports.enregistrerButton = exports.supprimerButton = exports.modifierButton = exports.creerButton = exports.supprimerPreferences = exports.preferencesAffichage = exports.imprimerTableButton = void 0;
// passer en localId sans avoir à ajouter this devant $$("nombutton") et @ts-ignore devant la ligne à chaque utilisation
// a condition de prouver que cela sert à quelque chose
const globals_1 = require("models/globals");
const tools_1 = require("./tools");
// export const imprimerTableButton = {
// 	id : "imprimerTableButton", value :"",
// 	view: "icon", icon: "mdi mdi-download-box-outline", tooltip: _("Générer pdf")
// 	, click : () => this.imprimer()
// }
function imprimerTableButton(datatableId, title) {
    return {
        id: "imprimerTableButtonId",
        view: "icon", icon: "mdi mdi-file-pdf-box", tooltip: (0, globals_1._)("Générer pdf"),
        click: (0, tools_1.imprimerTable)(datatableId, title)
    };
}
exports.imprimerTableButton = imprimerTableButton;
// export const preferencesAffichageButton = {
// 	id : "preferencesAffichageButton", value :"",
// 	view: "icon", icon: "mdi mdi-account-cog-outline", tooltip: _("Préférences d'affichage")
// 	, click : () => this.preferencesAffichage()
// }
function preferencesAffichage(datatableId, datatableColumns) {
    return {
        view: "icon", icon: "mdi mdi-account-cog-outline", tooltip: (0, globals_1._)("Préférences d'affichage"),
        popup: {
            view: "contextmenu",
            data: datatableColumns,
            // template:"#id#.#value#",
            template: function (obj) {
                // if (obj.hidden == true) {
                let dtable = $$(datatableId);
                if (dtable.isColumnVisible(obj.id)) {
                    return "<div class='webix_list_icon webix_icon wxi-eye'> "
                        + " " + "</div> " + obj.header;
                }
                else {
                    return "<div class='webix_list_icon webix_icon wxi-eye-slash'> "
                        + " " + "</div> " + obj.header;
                }
            },
            on: {
                onMenuItemClick(id) {
                    let dtable = $$(datatableId);
                    if (dtable.isColumnVisible(id))
                        dtable.hideColumn(id);
                    else
                        dtable.showColumn(id);
                    dtable.refreshColumns();
                    let list = this.data;
                    list.clearAll();
                    let xx = datatableColumns;
                    for (let i = 0; i < xx.length; i++) {
                        this.data.add(xx[i]);
                    }
                    this.hide();
                }
            }
        }
    };
}
exports.preferencesAffichage = preferencesAffichage;
function supprimerPreferences(datatableId, preferenceName) {
    return {
        view: "icon", icon: "mdi mdi-home-minus-outline", tooltip: (0, globals_1._)("Effacer toutes les préférences"),
        click: function () {
            webix.confirm({
                title: (0, globals_1._)("Confirmation"),
                text: (0, globals_1._)("Veuillez confirmer la suppression de toute la mise en forme de cette liste"),
                cancel: (0, globals_1._)("Annuler"),
                ok: (0, globals_1._)("OK")
            }).then(function () {
                let dtable = $$(datatableId);
                let v2 = "state" + dtable.config.id;
                webix.storage.local.remove(v2);
                dtable.resize();
                globals_1.lv2.userPrefs[preferenceName] = -1;
                webix.message((0, globals_1._)("Mise en forme supprimée"));
            });
        }
    };
}
exports.supprimerPreferences = supprimerPreferences;
exports.creerButton = {
    id: "creerButton", "view": "button", "hidden": true,
    type: "icon", icon: "mdi mdi-plus", "value": (0, globals_1._)("Créer")
};
exports.modifierButton = {
    "id": "modifierButton", "view": "button", "hidden": true,
    type: "icon", icon: "mdi mdi-file-document-edit-outline", "value": (0, globals_1._)("Modifier")
};
exports.supprimerButton = {
    id: "supprimerButton", "view": "button", "hidden": true, width: 160,
    type: "icon", icon: "mdi mdi-delete-forever-outline", "value": (0, globals_1._)("Supprimer")
};
exports.enregistrerButton = {
    id: "enregistrerButton", "view": "button", "hidden": true,
    type: "icon", icon: "mdi mdi-content-save-edit-outline", "value": (0, globals_1._)("Enregistrer")
};
exports.annulerButton = {
    id: "annulerButton", "view": "button", "hidden": true,
    type: "icon", icon: "mdi mdi-cancel", "value": (0, globals_1._)("Annuler")
};
exports.validerButton = {
    id: "validerButton", "view": "button", "hidden": true,
    type: "icon", icon: "mdi mdi-lock", "value": (0, globals_1._)("Valider")
};
exports.autresButton = {
    id: "autresButton", view: "button", icon: "mdi mdi-menu", tooltip: (0, globals_1._)("Autres options"),
    value: "", type: "icon"
};
exports.dupliquerButton = {
    id: "dupliquerButton", "view": "button", "hidden": true,
    type: "icon", icon: "mdi mdi-content-duplicate", "value": (0, globals_1._)("Dupliquer")
};
exports.actualiserButton = {
    id: "actualiserButton", "view": "icon", tooltip: (0, globals_1._)("Actualiser"),
    icon: "mdi mdi-reload", "value": ""
};
exports.ouvrirButton = {
    id: "ouvrirButton", "view": "button", width: 160, "hidden": true,
    type: "icon", icon: "mdi mdi-file-document-edit-outline", "value": (0, globals_1._)("Ouvrir")
};
exports.imprimerButton = {
    icon: "mdi mdi-download-box-outline", tooltip: (0, globals_1._)("Générer pdf"),
    id: "imprimerButton", "view": "button", "hidden": true, width: 160,
    type: "icon", "value": (0, globals_1._)("Imprimer")
};
exports.avoirButton = {
    icon: "mdi mdi-alpha-a-box-outline", tooltip: (0, globals_1._)("Générer un avoir"),
    id: "avoirButton", "view": "button", "hidden": true, width: 160,
    type: "icon", "value": (0, globals_1._)("Avoir")
};
exports.factureButton = {
    icon: "mdi mdi-alpha-f-box-outline", tooltip: (0, globals_1._)("Générer une facture"),
    id: "factureButton", "view": "button", "hidden": true, width: 160,
    type: "icon", "value": (0, globals_1._)("Facture")
};
